import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { action, observable, toJS } from 'mobx';
import 'react-quill/dist/quill.snow.css';
import isEqual from 'lodash/isEqual';
import noop from 'lodash/noop';
import { showValidationMessage } from '../field/utils';
import { ShowValidation } from '../form/enum';
import { FormField } from '../field/FormField';
import autobind from '../_util/autobind';
import BaseEditor from './BaseEditor';
import RichTextViewer from './RichTextViewer';
import { randomWord } from './utils';
import { RichTextToolbarType } from './enum';
const defaultRichTextOptions = {
    theme: 'snow',
};
let RichText = class RichText extends FormField {
    constructor() {
        super(...arguments);
        this.toolbarId = randomWord(false, 32, 64);
        this.rtOptions = this.getRichTextOptions();
    }
    getRichTextOptions(options = this.props.options) {
        if (options) {
            if (options.modules && options.modules.imageDropAndPaste !== false) {
                options.modules.imageDropAndPaste = true;
            }
        }
        else {
            options = {
                modules: {
                    toolbar: {
                        container: `#${this.toolbarId}`,
                    },
                    imageDropAndPaste: true,
                },
            };
        }
        return { ...defaultRichTextOptions, ...options };
    }
    get border() {
        return this.props.border;
    }
    showTooltip(e) {
        if (this.showValidation === ShowValidation.tooltip) {
            const message = this.getTooltipValidationMessage();
            if (message) {
                showValidationMessage(e, message, this.context.getTooltipTheme('validation'), this.context.getTooltipPlacement('validation'), this.getContextConfig);
                return true;
            }
        }
        return false;
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'defaultValue',
            'value',
            'border',
        ]);
    }
    getOtherProps() {
        const otherProps = super.getOtherProps();
        delete otherProps.disabled;
        return otherProps;
    }
    handleChange(value) {
        if (value && Number(value.length) === 1 && value[0].insert === '\n') {
            this.setValue(null);
        }
        else {
            this.setValue(value);
        }
    }
    // 禁用与只读表现一致
    // @autobind
    // setDisabled(disabled) {
    //   if(this.element && this.element.editor) {
    //     this.element.editor.getEditor().enable(!disabled);
    //   }
    // }
    elementReference(node) {
        if (node && node.editor) {
            this.element = node.editor;
        }
    }
    getWrapperClassNames(...args) {
        const { prefixCls, border, focused } = this;
        return super.getWrapperClassNames({
            [`${prefixCls}-border`]: border,
            [`${prefixCls}-focused`]: focused,
        }, ...args);
    }
    componentWillReceiveProps(nextProps, nextContext) {
        const { options } = nextProps;
        if (!isEqual(options, this.props.options)) {
            this.rtOptions = this.getRichTextOptions(options);
        }
        super.componentWillReceiveProps(nextProps, nextContext);
    }
    handleRichTextBlur(props) {
        const { onBlur = noop, defaultValue } = this.props;
        this.focused = false;
        onBlur(props);
        const deltaOps = this.getValue() || defaultValue || [];
        if (props.length === 0 && props.index === 0 && deltaOps.length === 0) {
            this.setValue(null);
        }
    }
    handleRichTextFocus(props) {
        const { onFocus = noop } = this.props;
        if (!this.disabled)
            this.focused = true;
        onFocus(props);
    }
    renderWrapper() {
        const { defaultValue, dataSet } = this.props;
        this.rtOptions.readOnly = this.disabled || this.readOnly;
        const deltaOps = this.getValue() || defaultValue;
        return (React.createElement("div", Object.assign({}, this.getWrapperProps(), { onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave }),
            React.createElement(BaseEditor, Object.assign({}, this.getOtherProps(), this.rtOptions, { saveRef: this.getOtherProps().ref, toolbarId: this.toolbarId, value: toJS(deltaOps), dataSet: dataSet, onBlur: this.handleRichTextBlur, onFocus: this.handleRichTextFocus })),
            this.renderFloatLabel()));
    }
};
RichText.displayName = 'RichText';
RichText.RichTextViewer = RichTextViewer;
RichText.defaultProps = {
    ...FormField.defaultProps,
    suffixCls: 'rich-text',
    autoFocus: false,
    mode: 'editor',
    border: true,
    toolbar: RichTextToolbarType.normal,
};
__decorate([
    observable
], RichText.prototype, "focused", void 0);
__decorate([
    autobind
], RichText.prototype, "handleChange", null);
__decorate([
    autobind
], RichText.prototype, "elementReference", null);
__decorate([
    autobind,
    action
], RichText.prototype, "handleRichTextBlur", null);
__decorate([
    autobind,
    action
], RichText.prototype, "handleRichTextFocus", null);
RichText = __decorate([
    observer
], RichText);
export default RichText;
